import React, { useState } from "react";
import "../../../css/CRUDModal.css";
import DeleteCourierHubConfirmationModal from "../DeleteCourierHubConfirmationModal";
import axios from "axios";
import CustomAlert from "../../../helpers/CustomAlert";
import { toast } from "react-toastify";
import {apiList, baseAuthUrl, baseUrl} from "../../../helpers/apiList";
import { axiosPostApi } from "../../../helpers/interceptorServices";
import AadhaarInput from "../../common/AadhaarInput";
import confetti from "canvas-confetti";

const AddCourierHub = ({
  show,
  handleClose,
  editData,
  action,
  fetchCustomerData,
  payloadData,
  setPayloadData,
  loggedInUserName,
  CloseCreate,
  handleSubmit,
}) => {
  // const loggedInUserName = sessionStorage.getItem("username");

  const [errors, setErrors] = useState({
    name: "",
    emailId: "",
    address1: "",
    address2: "",
    pinCode: "",
    firstContactPersonName: "",
    firstContactPersonMobileNo: "",
    gstNumber: "",
    aadharNumber: "",
    panNumber: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleInputChange = (e) => {
    const { id, value } = e.target;

    let updatedValue = value;

    if (id === "name" || id === "gstNumber" || id === "panNumber") {
      updatedValue = value.toUpperCase();
    } else if (id === "emailId") {
      updatedValue = value.toLowerCase();
    } else if (id === "firstContactPersonMobileNo") {
      updatedValue = value.replace(/[^0-9]/g, "");
    }

    setPayloadData((prev) => {
      const newPayload = { ...prev, [id]: updatedValue };

      if (id === "gstNumber") {
        if (updatedValue.length === 15) {
          const derivedPan = updatedValue.slice(2, 12);
          newPayload.panNumber = derivedPan;
        } else {
          newPayload.panNumber = "";
        }
      }

      return newPayload;
    });

    if (id === "pinCode") {
      validatePinCode(value);
    }
  };

  const handleSubmitWithValidation = () => {
    const validationErrors = validate();
    setErrors(validationErrors);

    // If there are no validation errors, proceed to submit
    if (
      Object.keys(validationErrors).length === 0 ||
      action === "view" ||
      action === "delete" ||
      action === "auth" ||
      (action === "modify" && !payloadData.aadharNumberRaw)
    ) {
      // handleSubmit(); // Call the handleSubmit function
      handleAddHubCustomer();
    } else {
      // Show error message or toast notification
      toast.error("Please fix all validation errors before proceeding", {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
      });

      // Scroll to first error field
      const firstErrorField = document.querySelector(".error");
      if (firstErrorField) {
        firstErrorField.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  };

  // Simple validation function
  const validate = () => {
    const newErrors = {};

    // Name validation (between 2 and 50 characters)
    payloadData.name = payloadData.name.trim();
    if (!payloadData.name) {
      newErrors.name = "Hub Name is required";
    } else if (
      // !/^[A-Za-z]+(?: [A-Za-z]+)*$/.test(payloadData.name) ||
      !/^[A-Za-z0-9@&.,'\- ]+$/.test(payloadData.name) ||
      payloadData.name.length < 2 ||
      payloadData.name.length > 50
    ) {
      newErrors.name = "Hub Name must be valid and between 2 and 50 characters";
    } else if (/^(.)\1{2,}$/.test(payloadData.name)) {
      newErrors.name = "Hub Name cannot be made of a single repeated character";
    }

    // Email validation (required and valid email)
    if (!payloadData.emailId) {
      newErrors.emailId = "Email is required";
    } else if (
      !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|pe|co\.[a-zA-Z]{2})$/.test(
        payloadData.emailId
      ) ||
      /\.com\./.test(payloadData.emailId) ||
      /\.co\.[a-zA-Z]{2}\./.test(payloadData.emailId)
    ) {
      newErrors.emailId = "Enter valid email ending with .com .co.xx or .in";
    }

    // Address validation
    payloadData.address1 = payloadData.address1.trim();
    if (!payloadData.address1) {
      newErrors.address1 = "Address is required";
    } else if (
      payloadData.address1.length < 5 ||
      payloadData.address1.length > 150
    ) {
      newErrors.address1 = "Address1 must be between 5 and 150 characters";
    } else if (
      !/^[A-Za-z0-9,.\/'#-][A-Za-z0-9,.\/'# -]*[A-Za-z0-9,.\/'#-]$/.test(
        payloadData.address1
      )
    ) {
      newErrors.address1 =
        "Address 1 contains invalid characters or starts/ends with spaces";
    } else if (!/[A-Za-z]/.test(payloadData.address1)) {
      newErrors.address1 = "Address 1 must contain at least one letter";
    }

    // Address 2 validation (required)
    payloadData.address2 = payloadData.address2.trim();
    if (!payloadData.address2) {
      newErrors.address2 = "Address is required";
    } else if (
      payloadData.address2.length < 5 ||
      payloadData.address2.length > 150
    ) {
      newErrors.address2 = "Address2 must be between 5 and 150 characters";
    } else if (
      !/^[A-Za-z0-9,.\/'#-][A-Za-z0-9,.\/'# -]*[A-Za-z0-9,.\/'#-]$/.test(
        payloadData.address2
      )
    ) {
      newErrors.address2 =
        "Address 2 contains invalid characters or starts/ends with spaces";
    } else if (!/[A-Za-z]/.test(payloadData.address2)) {
      newErrors.address2 = "Address 2 must contain at least one letter";
    }

    // Address 3 validation (optional)
    payloadData.address3 = payloadData.address3.trim();
    if (payloadData.address3) {
      if (
        payloadData.address3.length < 5 ||
        payloadData.address3.length > 150
      ) {
        newErrors.address3 = "Address 3 must be between 5 and 150 characters";
      } else if (
        !/^[A-Za-z0-9,.\/'#-][A-Za-z0-9,.\/'# -]*[A-Za-z0-9,.\/'#-]$/.test(
          payloadData.address3
        )
      ) {
        newErrors.address3 =
          "Address 3 contains invalid characters or starts/ends with spaces";
      } else if (!/[A-Za-z]/.test(payloadData.address3)) {
        newErrors.address3 = "Address 3 must contain at least one letter";
      }
    }
    if (!payloadData.pinCode) {
      newErrors.pinCode = "Pincode is required";
    } else if (!/^[1-9]\d{5}$/.test(payloadData.pinCode)) {
      newErrors.pinCode = "Pincode must be 6 digits and must not start with 0";
    }

    // First contact person name validation (between 2 and 50 characters)
    payloadData.firstContactPersonName =
      payloadData.firstContactPersonName.trim();
    if (!payloadData.firstContactPersonName) {
      newErrors.firstContactPersonName = "Contact person name is required";
    } else if (
      !/^[A-Za-z@&.,'\- ]+$/.test(payloadData.firstContactPersonName) ||
      payloadData.firstContactPersonName.length < 2 ||
      payloadData.firstContactPersonName.length > 50
    ) {
      newErrors.firstContactPersonName =
        "Contact person name must be between 2 and 50 characters and contain only letters";
    } else if (
      !/^[A-Za-z][A-Za-z .-]*[A-Za-z]$/.test(payloadData.firstContactPersonName)
    ) {
      newErrors.firstContactPersonName =
        "Contact person name must contain only letters, spaces, dots, or hyphens and cannot start or end with spaces or symbols";
    } else if (
      /^([A-Za-z])\1+$/.test(
        payloadData.firstContactPersonName.replace(/[ .-]/g, "")
      )
    ) {
      newErrors.firstContactPersonName =
        "Contact person name cannot consist of the same letter repeated";
    }

    // First contact person mobile number validation
    if (!payloadData.firstContactPersonMobileNo) {
      newErrors.firstContactPersonMobileNo =
        "Contact person mobile number is required";
    } else if (!/^[6789]\d{9}$/.test(payloadData.firstContactPersonMobileNo)) {
      newErrors.firstContactPersonMobileNo =
        "Mobile number must be 10 digits and start with 6, 7, 8, or 9";
    } else if (/^(\d)\1{9}$/.test(payloadData.firstContactPersonMobileNo)) {
      newErrors.firstContactPersonMobileNo =
        "Mobile number cannot have all repeated digits";
    } else if (
      payloadData.firstContactPersonMobileNo === "1234567890" ||
      payloadData.firstContactPersonMobileNo === "9876543210"
    ) {
      newErrors.firstContactPersonMobileNo =
        "Mobile number cannot be a simple sequence";
    }

    // GST Number Validation
    // if (!payloadData.gstNumber) {
    //   newErrors.gstNumber = "GST Number is required";
    // } else 
      if ( payloadData.gstNumber &&
      !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
        payloadData.gstNumber
      )
    ) {
      newErrors.gstNumber = "Invalid GST Number format";
    }

    // Aadhar Number Validation
    const aadharRaw = payloadData.aadharNumberRaw?.trim() || "";
    if (!aadharRaw) {
      newErrors.aadharNumber = "Aadhar Number is required";
    } else if (!/^[2-9]\d{11}$/.test(aadharRaw)) {
      newErrors.aadharNumber =
        "Aadhar Number must be exactly 12 digits and start with 2-9";
    } else if (/^(\d)\1{11}$/.test(aadharRaw)) {
      newErrors.aadharNumber = "Aadhar Number cannot have all repeated digits";
    }

    // PAN Number Validation
    // if (!payloadData.panNumber) {
    //   newErrors.panNumber = "PAN Number is required";
    // } else 
      if (payloadData.panNumber && !/^[A-Z]{5}[0-9]{4}[A-Z]{1}$/.test(payloadData.panNumber)) {
      newErrors.panNumber = "Invalid PAN Number format";
    }

    return newErrors;
  };

  const handleBlur = (e) => {
    const { id, value } = e.target;
    const fieldErrors = {};
    const trimmedValue = value.trim();

    switch (id) {
      case "name":
        if (!trimmedValue) {
          fieldErrors.name = "Hub Name is required";
        } else if (
          !/^[A-Za-z0-9@&.,'\- ]+$/.test(trimmedValue) ||
          trimmedValue.length < 2 ||
          trimmedValue.length > 50
        ) {
          fieldErrors.name =
            "Hub Name must be valid and between 2 and 50 characters";
        } else if (/^(.)\1{2,}$/.test(trimmedValue)) {
          fieldErrors.name =
            "Hub Name cannot be made of a single repeated character";
        } else {
          fieldErrors.name = ""; // ✅ Clear error if valid
        }
        break;

      case "emailId":
        if (!trimmedValue) {
          fieldErrors.emailId = "Email is required";
        } else if (
          !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9-]+\.(com|in|pe|co\.[a-zA-Z]{2})$/.test(
            trimmedValue
          ) ||
          /\.com\./.test(trimmedValue) ||
          /\.co\.[a-zA-Z]{2}\./.test(trimmedValue)
        ) {
          fieldErrors.emailId =
            "Enter valid email ending with .com .co.xx or .in";
        } else {
          fieldErrors.emailId = "";
        }
        break;

      case "address1":
        if (!trimmedValue) {
          fieldErrors.address1 = "Address is required";
        } else if (trimmedValue.length < 5 || trimmedValue.length > 150) {
          fieldErrors.address1 =
            "Address 1 must be between 5 and 150 characters";
        } else if (
          !/^[A-Za-z0-9,.\/'#-][A-Za-z0-9,.\/'# -]*[A-Za-z0-9,.\/'#-]$/.test(
            trimmedValue
          )
        ) {
          fieldErrors.address1 =
            "Address 1 contains invalid characters or starts/ends with spaces";
        } else if (!/[A-Za-z]/.test(trimmedValue)) {
          fieldErrors.address1 = "Address 1 must contain at least one letter";
        } else {
          fieldErrors.address1 = "";
        }
        break;

      case "address2":
        if (!trimmedValue) {
          fieldErrors.address2 = "Address is required";
        } else if (trimmedValue.length < 5 || trimmedValue.length > 150) {
          fieldErrors.address2 =
            "Address 2 must be between 5 and 150 characters";
        } else if (
          !/^[A-Za-z0-9,.\/'#-][A-Za-z0-9,.\/'# -]*[A-Za-z0-9,.\/'#-]$/.test(
            trimmedValue
          )
        ) {
          fieldErrors.address2 =
            "Address 2 contains invalid characters or starts/ends with spaces";
        } else if (!/[A-Za-z]/.test(trimmedValue)) {
          fieldErrors.address2 = "Address 2 must contain at least one letter";
        } else {
          fieldErrors.address2 = "";
        }
        break;

      case "address3":
        if (trimmedValue) {
          if (trimmedValue.length < 5 || trimmedValue.length > 150) {
            fieldErrors.address3 =
              "Address 3 must be between 5 and 150 characters";
          } else if (
            !/^[A-Za-z0-9,.\/'#-][A-Za-z0-9,.\/'# -]*[A-Za-z0-9,.\/'#-]$/.test(
              trimmedValue
            )
          ) {
            fieldErrors.address3 =
              "Address 3 contains invalid characters or starts/ends with spaces";
          } else if (!/[A-Za-z]/.test(trimmedValue)) {
            fieldErrors.address3 = "Address 3 must contain at least one letter";
          } else {
            fieldErrors.address3 = "";
          }
        } else {
          fieldErrors.address3 = "";
        }
        break;

      case "pinCode":
        if (!trimmedValue) {
          fieldErrors.pinCode = "Pincode is required";
        } else if (!/^[1-9]\d{5}$/.test(trimmedValue)) {
          fieldErrors.pinCode =
            "Pincode must be 6 digits and must not start with 0";
        } else {
          fieldErrors.pinCode = "";
        }
        break;

      case "firstContactPersonName":
        if (!trimmedValue) {
          fieldErrors.firstContactPersonName =
            "Contact person name is required";
        } else if (
          // !/^[A-Za-z@&.,'\- ]+$/.test(payloadData.firstContactPersonName) ||
          trimmedValue.length < 2 ||
          trimmedValue.length > 50
        ) {
          fieldErrors.firstContactPersonName =
            "Contact person name must be between 2 and 50 characters";
        } else if (!/^[A-Za-z][A-Za-z .-]*[A-Za-z]$/.test(trimmedValue)) {
          fieldErrors.firstContactPersonName =
            "Contact person name must contain only letters, spaces, dots, or hyphens and cannot start or end with spaces or symbols";
        } else if (/^([A-Za-z])\1+$/.test(trimmedValue.replace(/[ .-]/g, ""))) {
          fieldErrors.firstContactPersonName =
            "Contact person name cannot consist of the same letter repeated";
        } else {
          fieldErrors.firstContactPersonName = "";
        }
        break;

      case "firstContactPersonMobileNo":
        if (!trimmedValue) {
          fieldErrors.firstContactPersonMobileNo =
            "Contact person mobile number is required";
        } else if (!/^[789]\d{9}$/.test(trimmedValue)) {
          fieldErrors.firstContactPersonMobileNo =
            "Mobile number must be 10 digits and start with 7, 8, or 9";
        } else if (/^(\d)\1{9}$/.test(trimmedValue)) {
          fieldErrors.firstContactPersonMobileNo =
            "Mobile number cannot have all repeated digits";
        } else if (
          trimmedValue === "1234567890" ||
          trimmedValue === "9876543210"
        ) {
          fieldErrors.firstContactPersonMobileNo =
            "Mobile number cannot be a simple sequence";
        } else {
          fieldErrors.firstContactPersonMobileNo = "";
        }
        break;

      case "gstNumber":
        // if (!trimmedValue) {
        //   fieldErrors.gstNumber = "GST Number is required";
        // } else 
          if (trimmedValue &&
          !/^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z]{1}[1-9A-Z]{1}Z[0-9A-Z]{1}$/.test(
            trimmedValue
          )
        ) {
          fieldErrors.gstNumber = "Invalid GST Number format";
        } else {
          fieldErrors.gstNumber = "";
          if (trimmedValue.length === 15) {
            const derivedPan = trimmedValue.slice(2, 12);
            setPayloadData((prev) => ({
              ...prev,
              panNumber: derivedPan,
            }));
          }
        }
        break;

      case "aadharNumber":
        const aadharRaw = payloadData.aadharNumberRaw?.trim() || "";

        if (!aadharRaw) {
          fieldErrors.aadharNumber = "Aadhar Number is required";
        } else if (!/^[2-9]\d{11}$/.test(aadharRaw)) {
          fieldErrors.aadharNumber =
            "Aadhar Number must be exactly 12 digits and start with 2-9";
        } else if (/^(\d)\1{11}$/.test(aadharRaw)) {
          fieldErrors.aadharNumber =
            "Aadhar Number cannot have all repeated digits";
        } else {
          fieldErrors.aadharNumber = "";
        }
        break;

      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      ...fieldErrors,
    }));
  };

  const validatePinCode = (pinCode) => {
    let newErrors = { ...errors };

    if (!pinCode) {
      newErrors.pinCode = "Pincode is required";
    } else if (!/^\d{6}$/.test(pinCode)) {
      newErrors.pinCode = "Pincode must be 6 digits";
    } else {
      delete newErrors.pinCode;

      axios
        .get(`${baseAuthUrl}/sms/pincode/${pinCode}`)
        .then((response) => {
          const { status, message, data } = response.data;

          if (!status || !data || data.length === 0) {
            newErrors.pinCode = message || "Enter a valid Pincode";
          } else {
            const pinCodeData = data[0];
            const { cityName, state } = pinCodeData;
            setPayloadData((prevFormData) => ({
              ...prevFormData,
              city: cityName,
              state,
            }));

            delete newErrors.pinCode;
          }
          setErrors(newErrors);
        })
        .catch((error) => {
          newErrors.pinCode = "Error fetching pincode data";
          setErrors(newErrors);
        });
    }
  };

  const isViewMode = action === "view";
  const isDeleteMode = action === "delete";
  const isEditMode = action === "modify";
  const isAuthMode = action === "auth";

  const openModal = () => {
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };

  const handleBack = () => {
    handleClose();
    setErrors({});
  };

  const handleAddHubCustomer = () => {
    setLoading(true);
    const formData = new FormData();

    const payload = {
      username: formData.username || loggedInUserName,
      hubName: formData.name || payloadData.name,
      hubEmailId: formData.emailId || payloadData.emailId,
      addr1: formData.address1 || payloadData.address1,
      addr2: formData.address2 || payloadData.address2,
      addr3: formData.address3 || payloadData.address3,
      pinCode: formData.pinCode || payloadData.pinCode,
      state: formData.state || payloadData.state,
      city: formData.city || payloadData.city,
      contactPersonName:
        formData.firstContactPersonName || payloadData.firstContactPersonName,
      contactPersonMobileNo:
        formData.firstContactPersonMobileNo ||
        payloadData.firstContactPersonMobileNo,
      aadharNumber: formData.aadharNumber || payloadData.aadharNumber,
      gstNumber: formData.gstNumber || payloadData.gstNumber,
      panNumber: formData.panNumber || payloadData.panNumber,
      ...(isEditMode && { hubCode: editData.hubCode }),
    };

    let apiUrl = "";
    let successMessage = "";

    if (action === "add") {
      apiUrl = apiList.CREATE_COURIER_HUB;
      successMessage = "added successfully";
    } else if (action === "modify") {
      apiUrl = apiList.MODIFY_COURIER_HUB;
      successMessage = "modified successfully";
    }

    axiosPostApi(apiUrl, payload)
      .then((response) => {
        setLoading(false);
        if (response.status === 200 && response.data.status === true) {
          CustomAlert({
            title: "Success",
            text: response?.data?.message || successMessage,
            icon: "success",
            confirmButtonText: "Ok",
          });

          const canvas = document.createElement("canvas");
          canvas.style.position = "fixed";
          canvas.style.top = "0";
          canvas.style.left = "0";
          canvas.style.width = "100%";
          canvas.style.height = "100%";
          canvas.style.zIndex = "3000";
          document.body.appendChild(canvas);

          const confettiInstance = confetti.create(canvas, {
            resize: true,
            useWorker: true,
          });

          confettiInstance({
            particleCount: 250,
            spread: 100,
            origin: { y: 0.6 },
          });

          setTimeout(() => {
            document.body.removeChild(canvas);
          }, 3000);

          CloseCreate();
          fetchCustomerData(1);
        } else {
          CustomAlert({
            title: "Failed",
            text:
              response?.data?.message ||
              "There was an issue processing the request.",
            icon: "error",
            confirmButtonText: "Retry",
          });
        }
      })
      .catch((error) => {
        setLoading(false);
        console.error("Error:", error);
        CustomAlert({
          title: "Error",
          text: "An error occurred while processing.",
          icon: "error",
          confirmButtonText: "Retry",
        });
      });
  };

  const fieldDisabled = isViewMode || isDeleteMode || isAuthMode;
  return (
    <>
      <form>
        <div className="bg-white p-6 rounded-2xl shadow-sm">
          {/* All fields in a 3-column grid */}
          <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
            {/* GST Number */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                GST Number
              </label>
              <div className="relative">
                <i className="fa fa-file-invoice absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                <input
                  type="text"
                  id="gstNumber"
                  placeholder="GST Number"
                  maxLength={15}
                  value={payloadData.gstNumber}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  disabled={fieldDisabled || isEditMode}
                  className="w-full h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                           text-sm placeholder-gray-400 focus:outline-none focus:ring-2 focus:ring-[#FF702B]"
                />
              </div>
              {errors.gstNumber && (
                <p className="text-red-500 text-xs mt-1">{errors.gstNumber}</p>
              )}
            </div>

            {/* PAN Number */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                PAN No
              </label>
              <div className="relative">
                <i className="fa fa-id-card absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                <input
                  type="text"
                  id="panNumber"
                  placeholder="PAN No"
                  readOnly
                  value={payloadData.panNumber}
                  disabled={fieldDisabled || isEditMode}
                  className="w-full h-[42px] rounded-lg border border-gray-300 bg-gray-100 
                           pl-9 pr-3 text-sm placeholder-gray-400 cursor-not-allowed"
                />
              </div>
            </div>

            {/* Hub Name */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Hub Name <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <i className="fa fa-building absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                <input
                  type="text"
                  id="name"
                  placeholder="Hub Name"
                  value={payloadData.name}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  disabled={fieldDisabled}
                  className="w-full h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                           text-sm placeholder-gray-400 focus:ring-2 focus:ring-[#FF702B]"
                />
              </div>
              {errors.name && (
                <p className="text-red-500 text-xs mt-1">{errors.name}</p>
              )}
            </div>

            {/* Hub Email ID */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Hub Email Id <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <i className="fa fa-envelope absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                <input
                  type="email"
                  id="emailId"
                  placeholder="Hub Email Id"
                  value={payloadData.emailId}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  disabled={fieldDisabled}
                  className="w-full h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                           text-sm placeholder-gray-400 focus:ring-2 focus:ring-[#FF702B]"
                />
              </div>
              {errors.emailId && (
                <p className="text-red-500 text-xs mt-1">{errors.emailId}</p>
              )}
            </div>

            {/* Address 1 */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Address 1 <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <i className="fa fa-map-marker-alt absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                <input
                  type="text"
                  id="address1"
                  placeholder="Address 1"
                  value={payloadData.address1}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  disabled={fieldDisabled}
                  className="w-full h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                           text-sm placeholder-gray-400 focus:ring-2 focus:ring-[#FF702B]"
                />
              </div>
              {errors.address1 && (
                <p className="text-red-500 text-xs mt-1">{errors.address1}</p>
              )}
            </div>

            {/* Address 2 */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Address 2 <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <i className="fa fa-map-marker-alt absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                <input
                  type="text"
                  id="address2"
                  placeholder="Address 2"
                  value={payloadData.address2}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  disabled={fieldDisabled}
                  className="w-full h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                           text-sm placeholder-gray-400 focus:ring-2 focus:ring-[#FF702B]"
                />
              </div>
              {errors.address2 && (
                <p className="text-red-500 text-xs mt-1">{errors.address2}</p>
              )}
            </div>

            {/* Address 3 */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Address 3
              </label>
              <div className="relative">
                <i className="fa fa-map-marker-alt absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                <input
                  type="text"
                  id="address3"
                  placeholder="Address 3"
                  value={payloadData.address3}
                  onChange={handleInputChange}
                  onBlur={handleBlur}
                  disabled={fieldDisabled}
                  className="w-full h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                           text-sm placeholder-gray-400 focus:ring-2 focus:ring-[#FF702B]"
                />
              </div>
            </div>

            {/* Pin Code */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Pin Code <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <i className="fa fa-location-dot absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                <input
                  type="text"
                  id="pinCode"
                  placeholder="Pin Code"
                  value={payloadData.pinCode}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,6}$/.test(value)) handleInputChange(e);
                  }}
                  onBlur={handleBlur}
                  maxLength={6}
                  disabled={fieldDisabled}
                  className="w-full h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                           text-sm placeholder-gray-400 focus:ring-2 focus:ring-[#FF702B]"
                />
              </div>
              {errors.pinCode && (
                <p className="text-red-500 text-xs mt-1">{errors.pinCode}</p>
              )}
            </div>

            {/* State */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                State
              </label>
              <div className="relative">
                <i className="fa fa-flag absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                <input
                  type="text"
                  id="state"
                  placeholder="State"
                  value={payloadData.state || ""}
                  readOnly
                  className="w-full h-[42px] rounded-lg border border-gray-300 bg-gray-100 
                           pl-9 pr-3 text-sm text-gray-500 cursor-not-allowed"
                />
              </div>
            </div>

            {/* City */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                City
              </label>
              <div className="relative">
                <i className="fa fa-city absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                <input
                  type="text"
                  id="city"
                  placeholder="City"
                  value={payloadData.city || ""}
                  readOnly
                  className="w-full h-[42px] rounded-lg border border-gray-300 bg-gray-100 
                           pl-9 pr-3 text-sm text-gray-500 cursor-not-allowed"
                />
              </div>
            </div>

            {/* Contact Person Name */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Contact Person Name <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <i className="fa fa-user absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                <input
                  type="text"
                  id="firstContactPersonName"
                  placeholder="Contact Person Name"
                  value={payloadData.firstContactPersonName}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^[A-Za-z .-]*$/.test(value)) handleInputChange(e);
                  }}
                  onBlur={handleBlur}
                  maxLength={50}
                  disabled={fieldDisabled}
                  className="w-full h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                           text-sm placeholder-gray-400 focus:ring-2 focus:ring-[#FF702B]"
                />
              </div>
              {errors.firstContactPersonName && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.firstContactPersonName}
                </p>
              )}
            </div>

            {/* Contact Person Mobile No */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Contact Person Mobile No <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <i className="fa fa-phone absolute left-3 top-3 text-[#FF702B] text-sm"></i>
                <input
                  type="text"
                  id="firstContactPersonMobileNo"
                  placeholder="Contact Person Mobile No"
                  value={payloadData.firstContactPersonMobileNo}
                  onChange={(e) => {
                    const value = e.target.value;
                    if (/^\d{0,10}$/.test(value)) handleInputChange(e);
                  }}
                  onBlur={handleBlur}
                  maxLength={10}
                  disabled={fieldDisabled}
                  className="w-full h-[42px] rounded-lg border border-gray-300 pl-9 pr-3 
                           text-sm placeholder-gray-400 focus:ring-2 focus:ring-[#FF702B]"
                />
              </div>
              {errors.firstContactPersonMobileNo && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.firstContactPersonMobileNo}
                </p>
              )}
            </div>
            {/* Aadhar Number */}
            <div>
              <label className="text-sm font-medium text-gray-700 mb-1 block">
                Aadhar Number <span className="text-red-500">*</span>
              </label>
              <div className="relative">
                <i className="fa fa-id-badge absolute left-3 top-[9px] text-[#FF702B] text-sm"></i>
                <AadhaarInput
                  id="aadharNumber"
                  value={payloadData.aadharNumber}
                  onChange={(masked, raw) =>
                    setPayloadData((prev) => ({
                      ...prev,
                      aadharNumber: masked,
                      aadharNumberRaw: raw,
                    }))
                  }
                  onBlur={handleBlur}
                  disabled={fieldDisabled}
                  error={
                    !(
                      isViewMode ||
                      isDeleteMode ||
                      isAuthMode ||
                      (action === "modify" && !payloadData.aadharNumberRaw)
                    ) && errors.aadharNumber
                      ? errors.aadharNumber
                      : null
                  }
                />
              </div>
            </div>
          </div>
        </div>

        {/* Buttons */}
        <div className="scoped-modal modal-footer justify-center border-t-0">
          <button
            type="button"
            onClick={CloseCreate}
            className="btn btn-back w-[133px] !rounded-lg"
          >
            Cancel
          </button>
          {!(isViewMode || isAuthMode) && (
            <button
              type="button"
              onClick={handleSubmitWithValidation}
              className="btn btn-submit w-[133px] !rounded-lg"
              disabled={loading}
            >
              Submit
            </button>
          )}
        </div>

        <DeleteCourierHubConfirmationModal
          isOpen={isModalOpen}
          onClose={closeModal}
          editData={editData}
          fetchCustomerData={fetchCustomerData}
          handleClose={handleClose}
        />
      </form>
    </>
  );
};

export default AddCourierHub;
